sn-hero-header-type-6 {
  .sn-hero-header-type-6 {
    position: relative;
    padding-top: px-to-rem(40px);
    padding-bottom: px-to-rem(70px);

    @include desktop {
      padding-top: px-to-rem(80px);
      padding-bottom: px-to-rem(80px);
    }

    @include above(960px) {
      padding-top: px-to-rem(80px);
      padding-bottom: px-to-rem(100px);
    }

    @include above(1440px) {
      padding-bottom: px-to-rem(120px);
    }
  }

  .sn-hero-header-type-6__container {
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 px-to-rem(16px);

    @include desktop {
      padding: 0 px-to-rem(24px);
    }
  }

  .sn-hero-header-type-6__row {
    @include above(960px) {
      display: flex;
      align-items: flex-start;
      gap: px-to-rem(84px);
    }
  }

  // ── Left column (contact-us) ─────────────────────────────────────
  .sn-hero-header-type-6__column--contact-us {
    text-align: center;
    margin-bottom: px-to-rem(30px);

    @include above(768px) {
      margin-bottom: px-to-rem(72px);
    }

    @include above(960px) {
      display: flex;
      flex-direction: column;
      text-align: left;
      flex: 1;
      margin-bottom: 0;
    }

    me-heading {
      display: block;
      font-size: px-to-rem(20px);
      line-height: px-to-rem(28px);
      margin-top: 0;
      margin-bottom: px-to-rem(11px);

      @include desktop {
        font-size: px-to-rem(24px);
        line-height: px-to-rem(36px);
        margin-bottom: px-to-rem(12px);
      }

      @include above(960px) {
        font-size: px-to-rem(28px);
        line-height: px-to-rem(40px);
        margin-bottom: px-to-rem(10px);
      }

      @include above(1440px) {
        font-size: px-to-rem(36px);
        line-height: px-to-rem(48px);
        margin-bottom: px-to-rem(16px);
      }
    }

    me-text {
      display: block;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(20px);
      margin-bottom: px-to-rem(17px);

      @include desktop {
        font-size: px-to-rem(16px);
        line-height: px-to-rem(24px);
        margin-bottom: px-to-rem(28px);
      }

      @include above(1440px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
        margin-bottom: px-to-rem(40px);
      }
    }
  }

  // ── Label (uppercase tagline, matches sn-advantages label "Benefits") ──
  .sn-hero-header-type-6__label {
    me-tagline {
      display: block;
      color: var(--text-color-primary);
      margin-bottom: px-to-rem(12px);
      text-align: center;
      text-transform: uppercase;

      @include above(960px) {
        text-align: left;
      }
    }
  }

  // ── Right column (form) ──────────────────────────────────────────
  .sn-hero-header-type-6__column--form {
    display: flex;
    justify-content: center;

    @include above(768px) {
      width: px-to-rem(450px);
      margin: 0 auto;
      display: block;
    }

    @include above(960px) {
      flex: 1;
      width: auto;
      margin: 0;
      display: block;
    }
  }

  // ── Benefits checklist ───────────────────────────────────────────
  .sn-hero-header-type-6__benefits {
    display: none;
    text-align: left;

    @include above(960px) {
      display: block;
    }

    .me-list__item {
      position: relative;
      font-weight: 700;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(20px);
      padding-left: px-to-rem(35px);
      padding-bottom: px-to-rem(24px);

      @include above(960px) {
        padding-left: px-to-rem(39px);
        padding-bottom: px-to-rem(7px);
        max-width: px-to-rem(370px);
      }

      @include above(1440px) {
        font-size: px-to-rem(16px);
        line-height: px-to-rem(28px);
        padding-bottom: px-to-rem(24px);
        max-width: px-to-rem(460px);
      }

      .me-list__icon {
        display: none;
      }

      &::before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;

        // Orange circle checkmark (#FFF3E6 bg, #FF9001 check)
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjUnIHZpZXdCb3g9JzAgMCAyNCAyNScgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48Y2lyY2xlIGN4PScxMicgY3k9JzEyLjYxODcnIHI9JzEyJyBmaWxsPScjRkZGM0U2Jy8+PHBhdGggZmlsbC1ydWxlPSdldmVub2RkJyBjbGlwLXJ1bGU9J2V2ZW5vZGQnIGQ9J00xNC42NDY3IDkuMDg1OTRDMTUuMTIwNCA4LjUzMjQzIDE1Ljk1NTQgOC40NjA4IDE2LjUxODIgOC45MjM4MkMxNy4wODg3IDkuMzkzMjIgMTcuMTYzNyAxMC4yMzQgMTYuNjgzNSAxMC43OTUxTDExLjUyOTYgMTYuODE4QzExLjI2NjEgMTcuMTI1OSAxMC44ODExIDE3LjI5MzIgMTAuNTEwNSAxNy4yODVDMTAuMTEyNCAxNy4yOTMyIDkuNzI3NDMgMTcuMTI1OSA5LjQ2Mzk4IDE2LjgxOEw3LjMxNjUgMTQuMzA4NUM2LjgzNjMgMTMuNzQ3MyA2LjkxMTMxIDEyLjkwNjYgNy40ODE4MSAxMi40MzcyQzguMDQ0NTUgMTEuOTc0MiA4Ljg3OTYxIDEyLjA0NTggOS4zNTMyNSAxMi41OTkzTDEwLjQ5NjggMTMuOTM1NkwxNC42NDY3IDkuMDg1OTRaJyBmaWxsPScjRkY5MDAxJy8+PC9zdmc+');
        background-size: contain;
        background-repeat: no-repeat;
        width: px-to-rem(24px);
        height: px-to-rem(24px);
      }
    }
  }

  // ── Form wrapper card ─────────────────────────────────────────────
  .sn-hero-header-type-6__form-wrapper {
    display: block;
    width: 100%;
    position: relative;
    background: var(--background-color-primary);
    box-shadow: 0 5px 25px 0 rgb(0 0 0 / 10%);
    padding: px-to-rem(36px) px-to-rem(16px) px-to-rem(32px);
    margin: 0 px-to-rem(-16px) px-to-rem(34px);

    @include desktop {
      border-radius: var(--radius-size-md);
      margin: 0 auto px-to-rem(56px);
      padding: px-to-rem(40px) px-to-rem(36px);
    }

    @include above(960px) {
      padding: px-to-rem(40px);
      box-shadow: 0 15px 25px 0 rgb(0 0 0 / 10%);
      margin: 0;
    }

    @include above(1200px) {
      box-shadow: 0 20px 80px 0 rgb(0 0 0 / 10%);
      padding: px-to-rem(44px) px-to-rem(52px);
    }

    // Rotated #D5E6FF block behind the white card
    &::after {
      @include desktop {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #63b4ff;
        border-radius: var(--radius-size-lg);
        transform: rotate(7deg);
        z-index: -1;
      }
    }

    .sn-hero-header-type-6__form-header {
      margin-bottom: px-to-rem(20px);
    }

    .sn-hero-header-type-6__form-title {
      display: block;
      font-weight: 700;
      color: var(--text-color-primary);
      margin-bottom: px-to-rem(4px);

      .me-text {
        font-size: px-to-rem(18px);
        line-height: px-to-rem(26px);
        margin-bottom: 0;

        @include above(960px) {
          font-size: px-to-rem(24px);
          line-height: px-to-rem(24px);
        }
      }
    }

    .sn-hero-header-type-6__form-notice {
      display: block;
      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--color-text-secondary, #666);
    }

    me-input,
    me-select {
      display: block;
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }
    }

    .sn-hero-header-type-6__form-row {
      display: flex;
      gap: px-to-rem(12px);
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }

      me-input,
      me-select {
        flex: 1 1 0;
        min-width: 0;
        margin-bottom: 0;
      }
    }

    me-button {
      display: block;
      width: 100%;
      margin-bottom: px-to-rem(16px);

      .me-button {
        width: 100%;
      }
    }

    .sn-hero-header-type-6__agreement-note {
      display: block;
      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--color-text-secondary, #666);
      margin-bottom: 0;
      text-align: center;

      a {
        color: var(--text-color-brand-primary);
        text-decoration: underline;

        &:hover {
          color: #008bf8;
        }
      }
    }
  }
}
